// extracted by mini-css-extract-plugin
export default {"fullscreenLoadingContainer":"fullscreen-loading_fullscreenLoadingContainer__3eqtH","fullscreenLoadingImage":"fullscreen-loading_fullscreenLoadingImage__dT7ay"};